import { render, staticRenderFns } from "./InfoHeader.vue?vue&type=template&id=7188006c&"
import script from "./InfoHeader.vue?vue&type=script&lang=js&"
export * from "./InfoHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports